import React, { ElementType, FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { ListItemIcon } from '@savebetter/components';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface ListIcon2Item extends SbBlokData {
  text: string;
}

export interface Blok extends PageSectionBlok {
  title: string;
  items: ListIcon2Item[];
}

interface ListIcon2Props extends PageSectionProps {
  blok: Blok;
  sectionTitleWrapper?: ElementType | null;
}

export const ListIcon2: FunctionComponent<React.PropsWithChildren<ListIcon2Props>> = ({ blok, sectionClassName }) => {
  const {
    title,
    items = [],
    hasPaddingBottom = false,
    hasPaddingTop = false,
    hasBackground = false,
    hasBorder = false
  } = blok;

  return (
    <Section
      width="md"
      blok={blok}
      className={sectionClassName}
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <p className="text-center mb-4 font-bold text-4xl">{title}</p>
      <ul className="p-0">
        {items.map((item: ListIcon2Item) => (
          <ListItemIcon
            text={item.text}
            kind="small"
            icon="SecondarySuccess"
            key={item._uid}
            {...storyblokEditable(item)}
          />
        ))}
      </ul>
    </Section>
  );
};
